
import PropTypes from 'prop-types';
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, useTheme, TableContainer, Card, Table, TableBody, Button, Tabs, Tab, alpha, Box, Dialog, DialogActions, FormControl, FormGroup, FormControlLabel, Switch } from '@mui/material';
import { useSettingsContext } from '../../../../components/settings/index.js';
import { useTable, TableHeadCustom, TablePaginationCustom } from '../../../../components/table/index.js';
import CustomBreadcrumbs from '../../../../components/custom-breadcrumbs/index.js';
import { RouterLink } from '../../../../routes/components/index.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../../../components/snackbar/index.js';
import { PDFViewer } from '@react-pdf/renderer';
import { useBoolean } from '../../../../hooks/use-boolean.js';
import Iconify from '../../../../components/iconify/iconify.js';
import AssignedReportTableRow from './assigned-report-table-row.js';
import AssignedReportTableToolBar from './assigned-report-table-toolbar.js';
import AssignedPDF from './assigned-view-pdf.js';
import Label from '../../../../components/label/index.js';
import Scrollbar from 'src/components/scrollbar/scrollbar.js';
import { GET_TRAINERASSESSOR } from "../../../../graphql/modules/users.js";
import ReportGraph from '../reportgraphq/report-graph.js';
import { startOfMonth, endOfMonth } from 'date-fns';



// GRAPHQL
import { GET_ASSIGNED_TA_CLASS, DELETE_CLASSES, CANCELLED_CLASS, COMPLETED_CLASS, REVERT_CLASS } from "../../../../graphql/modules/_client/class.js";
import { useQuery, useMutation } from "@apollo/react-hooks";

const STATUS_OPTION = [
  { value: '', label: 'All', role: ['superadmin', 'admin', 'bo', 'tm', 'ta'] },
  { value: 'Confirmed', label: 'Confirmed', role: ['superadmin', 'admin', 'bo', 'tm', 'ta'] },
  { value: 'Completed', label: 'Completed', role: ['superadmin', 'admin', 'bo', 'tm', 'ta'] },
  { value: 'Draft', label: 'Draft', role: ['superadmin', 'admin', 'bo', 'tm'] },
  { value: 'Cancelled', label: 'Cancelled', role: ['superadmin', 'admin', 'bo', 'tm'] },
]
// const STATUS_OPTION_TA = [
//   {value: 'all', label: 'All'},
//   {value: 'confirmed', label: 'Confirmed'},
//   {value: 'completed', label: 'Completed'},
// ]
const TABLE_HEAD = [
  { id: 'courseRunId', label: 'Course Run ID' },
  { id: 'classCode', label: 'Class Code' },
  { id: 'courseTitle', label: 'Course Title' },
  { id: 'trainerAssessor', label: 'Trainer/Assesor' },
  { id: 'courseDates.start', label: 'Course Start Date' },
  { id: 'courseDates.end', label: 'Course End Date' }
]

const defaultFilters = {
  name: '',
  dateFrom: null,
  dateTo: null,
  status: ''
}

export function AssignedListViewReport({ companyinfo }) {
  const { fullName } = useSelector((state) => state?.auth?.user);
  const { nricFin } = useSelector((state) => state?.auth?.user);
  const company = useSelector((state) => state?.auth?.company);
  const isRole = useSelector((state) => state?.auth?.isRole);
  const companyProfile = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
  const company_name = useSelector((state) => state?.auth?.companyProfile?.companyProfile?.companyName);
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const attendanceDG = useBoolean();
  const table = useTable();
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const [filters, setFilters] = useState('');
  const [searchText, setSearch] = useState(defaultFilters);
  const [companyName, setCompanyName] = useState("iatos");
  const [page, setPage] = useState(1);
  const [results, setResults] = useState(null);
  const [classAtt, setClassAtt] = useState(null);
  const [trainer, setTrainer] = useState(null);
  const [switchGraph, setSwitchGraph] = useState(false);


  const [DeleteClassMutation] = useMutation(DELETE_CLASSES);
  const [CancelledClassMutation] = useMutation(CANCELLED_CLASS);
  const [CompleteClassMutation] = useMutation(COMPLETED_CLASS);
  const [RevertClassMutation] = useMutation(REVERT_CLASS);

  const { data: trainerInfo } = useQuery(GET_TRAINERASSESSOR, {
    variables: {
      companyName: state?.info?.databaseName || company,
    },
    fetchPolicy: "cache-and-network",
  });

  const { data, loading, error, refetch } = useQuery(GET_ASSIGNED_TA_CLASS, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: searchText,
      companyName: state?.databaseName || company,
      order: table.order || 'desc',
      orderBy: table.orderBy || 'courseDates.start',
      filterBy: nricFin,
      isRole: isRole
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (data) {
      setResults(data?.getAssignedTAClass)
      setTrainer(trainerInfo?.getTrainerAssessor)
    }
  }, [data])



  const handleFilters = useCallback((name, value) => {
    setSearch(prevState => ({
      ...prevState,
      [name]: value
    }));
  }, [table]
  );

  const handleDeleteRow = useCallback(async (row) => {
    const { data: { deleteClass } } = await DeleteClassMutation({
      variables: {
        _id: row?._id,
        companyName: state?.databaseName || company,
        fullName: fullName
      }
    })
    if (deleteClass?.success) {
      enqueueSnackbar(deleteClass?.message, { variant: 'success' });
      refetch();
    } else {
      enqueueSnackbar(deleteClass?.message, { variant: 'error' });
    }
  }, [refetch]);

  const handleCancelledRow = useCallback(async (row) => {
    const { data: { cancelledClass } } = await CancelledClassMutation({
      variables: {
        _id: row?._id,
        companyName: state?.databaseName || company,
        fullName: fullName,
        courseRunId: row?.courseRunId,
        courseReferenceNumber: row?.course?.tsgRefNumber,
        status: row?.status,
        uen: companyProfile?.uen,
        encryptionkey: companyProfile?.encryptionKey,
        _companyName: companyProfile?.companyName,
      }
    })
    if (cancelledClass?.success) {
      enqueueSnackbar(cancelledClass?.message, { variant: 'success' });
      refetch();
    } else {
      enqueueSnackbar(cancelledClass?.message, { variant: 'error' });
    }
  }, [refetch]);

  const handleCompleted = useCallback(async (row) => {
    const { data: { completedClass } } = await CompleteClassMutation({
      variables: {
        _id: row?._id,
        companyName: state?.databaseName || company,
        fullName: fullName
      }
    })
    if (completedClass?.success) {
      enqueueSnackbar(completedClass?.message, { variant: 'success' });
      refetch();
    } else {
      enqueueSnackbar(completedClass?.message, { variant: 'error' });
    }
  }, [refetch]);

  const handleRevertBack = useCallback(async (row) => {
    const { data: { revertClass } } = await RevertClassMutation({
      variables: {
        _id: row?._id,
        companyName: state?.databaseName || company,
        fullName: fullName
      }
    })
    if (revertClass?.success) {
      enqueueSnackbar(revertClass?.message, { variant: 'success' });
      refetch();
    } else {
      enqueueSnackbar(revertClass?.message, { variant: 'error' });
    }
  }, [refetch]);


  const handleFilterStatus = useCallback(
    (event, newValue) => {
      if (newValue !== "all") {
        setSearch(prevState => ({
          ...prevState,
          "status": newValue
        }));
        setFilters(newValue);
      } else {
        setFilters(newValue);
        setSearch('');
      }

    },
    [table]
  );



  const handleViewAccount = useCallback((row) => {
    navigate('/company-view-account', { state: row })
  },
    []
  );
  const handleEditRow = useCallback((row) => {
    navigate('/company-create-update-classes', { state: { info: companyinfo, classInfo: row } })
  });

  const handleView = useCallback(
    (row) => {
      setClassAtt(row)
    },
    []
  );

  const handleCreateNewClass = useCallback(() => {
    navigate(`/${company}/reports`, { state: { info: companyinfo } })

  });


  const handleReset = useCallback(async () => {
    setSearch(defaultFilters);
    setFilters('')
  }, [setSearch])

  const handlePrintAssigned = useCallback(async () => {
    if (searchText?.name !== "") {
      const getAll = await refetch({
        limit: 0,
        offset: 0,
        searchText: searchText,
        companyName: state?.databaseName || company,
        order: table.order || 'desc',
        orderBy: table.orderBy || 'courseDates.start',
        filterBy: nricFin,
        isRole: isRole
      })
      if (getAll?.data) {
        setClassAtt(getAll?.data?.getAssignedTAClass?.results)
        attendanceDG.onTrue();
        // refetch({
        //   limit: table?.rowsPerPage,
        //   offset: table?.page,
        //   searchText: searchText,
        //   companyName: state?.databaseName || company,
        //   order: table.order || 'desc',
        //   orderBy: table.orderBy || 'courseDates.start',
        //   filterBy: nricFin,
        //   isRole: isRole
        // });
      }
    } else {
      enqueueSnackbar("Please select Trainer/Assessor", { variant: 'warning' });
    }
  });

  const handleSwitchChange = (event) => {
    setSwitchGraph(event.target.checked);
    if (event.target.checked === true) {
      setSearch({
        dateFrom: null,
        dateTo: null
      })
    } else {
      setSearch({
        dateFrom: null,
        dateTo: null
      })
    }
  };


const grouped = results?.results.reduce((acc, item) => {
  const title = item.course.courseTitle;

  if (!acc[title]) {
    acc[title] = [];
  }

  acc[title].push(item);

  return acc;
}, {});

const displayGraph = grouped && Object?.entries(grouped)?.map(([courseTitle, items]) => ({
  courseTitle,
  count: items?.length
}));

console.log(displayGraph)



  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading={`${companyinfo?.companyName || company_name} - Trainer/Assessor Class Assigned Report`}
        links={[
          { name: 'Dashboard' },
          { name: 'Trainer/Assessor Class Assigned Report' }
        ]}
        action={
          <>
            <FormControl component="fieldset">
              <FormGroup aria-label="position">
                <FormControlLabel
                  value="bottom"
                  control={<Switch color="primary" onChange={handleSwitchChange} />}
                  label={!switchGraph ? "Switch to Graph" : "Switch to Table"}
                  labelPlacement="bottom"
                />
              </FormGroup>
            </FormControl>
            <Button
              componet={RouterLink}
              onClick={handleCreateNewClass}
              variant="contained"
              startIcon={<Iconify icon="mingcure:add-line" />}
              sx={{
                display: isRole.some((role) => ["bo", "tm"].includes(role)) ? '' : 'none'
              }}
            >
              Go Back
            </Button>
          </>
        }
      />

      {
        !switchGraph ?

          <Card>
            <Tabs
              value={filters}
              onChange={handleFilterStatus}
              sx={{
                px: 2.5,
                boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`
              }}
            >
              {STATUS_OPTION.map((tab) => (
                <Tab
                  key={tab?.value}
                  iconPosition='end'
                  value={tab?.value}
                  label={tab?.label}
                  icon={
                    <Label
                      variant={
                        ((tab.value === '' || tab.value === filters.status) && 'filled') || 'soft'
                      }
                      color={
                        (tab.value === 'Confirmed' && 'success') || (tab.value === 'Completed' && 'info') || (tab.value === 'Draft' && 'warning') || (tab.value === 'Cancelled' && 'error') || 'default'
                      }
                    >
                      {tab.value === '' && results?.count}
                      {tab.value === 'Confirmed' && results?.confirmed}
                      {tab.value === 'Completed' && results?.completed}
                      {tab.value === 'Draft' && results?.draft}
                      {tab.value === 'Cancelled' && results?.cancelled}
                    </Label>
                  }
                  sx={{
                    display: isRole.some((role) => tab?.role?.includes(role)) ? '' : 'none'
                  }}
                />

              ))}

            </Tabs>

            <AssignedReportTableToolBar onFilters={handleFilters} handlePrintAssigned={() => handlePrintAssigned()} trainer={trainer} handleReset={handleReset} searchText={searchText} />
            <Scrollbar>
              <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                <Table sx={{ minWidth: 960 }}>

                  <TableHeadCustom
                    headLabel={TABLE_HEAD}
                    order={table.order}
                    orderBy={table.orderBy}
                    onSort={table.onSort}
                  />



                  <TableBody>

                    {results?.results?.map((row) => (
                      <AssignedReportTableRow
                        key={row?.id}
                        row={row}
                        onViewRow={() => handleView(row)}
                        onDeleteRow={() => handleDeleteRow(row)}
                        onEditRow={() => handleEditRow(row)}
                        onCancelledRow={() => handleCancelledRow(row)}
                        onCompleted={() => handleCompleted(row)}
                        onRevert={() => handleRevertBack(row)}
                      />
                    ))}


                  </TableBody>

                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePaginationCustom
              count={results?.count}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          </Card>

          :
          <ReportGraph
            title="Trainer/Assessor Class Assigned"
            chart={{
              categories: displayGraph?.map((item) => item?.courseTitle),
              series: [
                {
                  year: '2024',
                  data: [
                    {
                      name: "Assigned Class",
                      data: displayGraph?.map((item) => item?.count)
                    }
                  ] 
                }
              ],
            }}
            onFilters={handleFilters}
            searchText={searchText}
            trainer={trainer}
          />
      }

      <Dialog fullScreen open={attendanceDG.value}>
        <Box sx={{ height: 1, display: 'flex', flexDirection: 'column' }}>
          <DialogActions
            sx={{
              p: 1.5,
            }}
          >
            <Button color="inherit" variant="contained" onClick={attendanceDG.onFalse}>
              Close
            </Button>
          </DialogActions>

          <Box sx={{ flexGrow: 1, height: 1, overflow: 'hidden' }}>
            <PDFViewer width="100%" height="100%" style={{ border: 'none' }}>
              <AssignedPDF assigned={classAtt} companyProfile={companyProfile} searchText={searchText?.name} />
            </PDFViewer>
          </Box>
        </Box>
      </Dialog>

    </Container>
  );
}

AssignedListViewReport.propTypes = {
  companyinfo: PropTypes.object,
};